const SingleChat = "SingleChat";
const GroupChat = "GroupChat";

const WebSql = {
  ctx: null,
  init(ctx) {
    this.ctx = ctx;
    this.openDB(this.chatDB.name, this.chatDB.version);
    this._friendList = this.ctx.$preference.getFriendList();
    this._reqList = this.ctx.$preference.getFriReqList();
    this._refuseList = this.ctx.$preference.getRefuseList();
  },
  
  logout(){
    this._first_friend_get = true;
    this._first_fri_req_get = true;
    this._first_refuse_get = true;
  },
  
  onLoginOK(){
    this._dialogueList = this.ctx.$preference.getDialogueList(this.ctx.$info.id)
    this._first_friend_get = true;
    this._first_fri_req_get = true;
    this._first_refuse_get = true;
  },
  
  _reqList: [],
  _first_fri_req_get: true,
  addFriendReq(data) {
    if(!this._reqList.push){
      this._reqList = []
    }
    for(const item of this._reqList){
      if(item.id == data.id){
        return
      }
    }
    this._reqList.push(data)
    this.ctx.$preference.setFriReqList(this._reqList)
  },
  delFriReq(id){
    for(let i=0; i<this._reqList.length; i++){
      let item = this._reqList[i]
      if(item.id == id){
        this._reqList.splice(i, 1)
        break;
      }
    }
    this.ctx.$preference.setFriReqList(this._reqList)
  },
  getFriReqList(onGet) {
    let self = this;
    if(self._first_fri_req_get){
      // this.ctx.$http_data.friendListGet(function (data) {
      //   self._first_fri_req_get = false;
      //   self._reqList = [];
      //   for(const item of data){
      //     self._reqList.push(item)
      //   }
      //   self.ctx.$preference.setFriReqList(self._reqList)
      //   onGet(self._reqList)
      // }, function (err) {
      //   onGet(self._reqList)
      // })
      onGet(self._reqList)
    }else{
      onGet(self._reqList)
    }
  },
  
  _friendList: [],
  _first_friend_get: true,
  addFriend(data) {
    if(!this._friendList.push){
      this._friendList = []
    }
    for(const item of this._friendList){
      if(item.id == data.id){
        return
      }
    }
    this._friendList.push(data);
    this.ctx.$preference.setFriendList(this._friendList)
    this.delRefuse(data.id)
  },
  delFriend(id){
    for(let i=0; i<this._friendList.length; i++){
      let item = this._friendList[i]
      if(item.id == id){
        this._friendList.splice(i, 1)
        break;
      }
    }
    this.ctx.$preference.setFriendList(this._friendList)
  },
  getFriendList(onGet) {
    let self = this;
    if(self._first_friend_get){
      this.ctx.$http_data.friendListGet(function (data) {
        self._first_friend_get = false;
        self._friendList = [];
        for(const item of data){
          self._friendList.push(item)
        }
        self.ctx.$preference.setFriendList(self._friendList)
        onGet(self._friendList)
      }, function (err) {
        onGet(self._friendList)
      })
    }else{
      onGet(self._friendList)
    }
  },
  
  getFriendCacheList() {
    return this._friendList
  },
  
  _refuseList: [],
  _first_refuse_get: true,
  
  addRefuse(data){
    if(!this._refuseList.push){
      this._refuseList = []
    }
    for(const item of this._refuseList){
      if(item.id == data.id){
        return
      }
    }
    this._refuseList.push(data);
    this.ctx.$preference.setRefuseList(this._refuseList)
  },
  delRefuse(id){
    for(let i=0; i<this._refuseList.length; i++){
      let item = this._refuseList[i]
      if(item.id == id){
        this._refuseList.splice(i, 1)
        break;
      }
    }
    this.ctx.$preference.setRefuseList(this._refuseList)
  },
  getRefuseList(onGet) {
    let self = this;
    if(self._first_refuse_get){
      this.ctx.$http_data.refuseListGet(function (data) {
        self._first_refuse_get = false;
        self._refuseList = [];
        for(const item of data){
          self._refuseList.push(item)
        }
        self.ctx.$preference.setRefuseList(self._refuseList)
        onGet(self._refuseList)
      }, function (err) {
        onGet(self._refuseList)
      })
    }else{
      onGet(self._refuseList)
    }
  },
  
  //接单-进群
  joinGroup(id, order){
    let self = this
    this.ctx.$http_data.groupJoin(id, function (data) {
      if(order){
        data.order = order
      }
      self.ctx.$store.commit('naveTo', {vue: self.ctx, path: self.ctx.$router_path.mochatDialogue, param:data})
    }, function (data) {
      self.ctx.$http_data.toastErrorMsg(data)
      if(data.errCode == 1000){
        self.delDialog(id)
      }
    })
  },
  
  _dialogueList: [],
  addDialogue(data){
    // {mode:'single', user:{user info}}
    // {mode:'group', user:{group info}, info: {}}
    data.time = new Date().getTime()
    let push = true
    for(const item of this._dialogueList){
      if(item.id == data.id){
        item.time = data.time
        item.detail = data.detail
        item.user = data.user
        
        if(data.order){
          item.order = data.order
        }
        
        push = false
        break;
      }
    }
    if(push){
      this._dialogueList.push(data);
    }
    this._dialogueList = this.dialogSort(this._dialogueList)
    this.ctx.$preference.setDialogueList(this._dialogueList, this.ctx.$info.id)
  },
  //置顶聊天
  firstDialog(key, first){
    for(const item of this._dialogueList){
      if(item.id == key){
        item.first = first
      }
    }
    this._dialogueList = this.dialogSort(this._dialogueList)
    this.ctx.$preference.setDialogueList(this._dialogueList, this.ctx.$info.id)
  },
  setLastDialogueMsg(chat){
    for(const item of this._dialogueList){
      if(item.id == chat.owner){
        item.msg = chat
        break;
      }
    }
  },
  //聊天列表排序
  dialogSort(arr) {
    let len = arr.length;
    for(let i = 0; i < len; i++){
      for(let j = 0; i < len - 1 - i; i++){
        if(arr[j].first){
          let temp = arr[j+1];//元素交换
          arr[j+1] = arr[j];
          arr[j] = temp;
        }else{
          if(arr[j].time > arr[j+1].time) {//相邻元素两两对比
            let temp = arr[j+1];//元素交换
            arr[j+1] = arr[j];
            arr[j] = temp;
          }
        }
      }
    }
    return arr;
  },

  delDialog(id){
    for(let i=0; i<this._dialogueList.length; i++){
      let item = this._dialogueList[i]
      if(item.id == id){
        this._dialogueList.splice(i, 1)
        this.ctx.$preference.setDialogueList(this._dialogueList, this.ctx.$info.id)
        break;
      }
    }
  },
  saveDialogReceipt(id){
    for(let i=0; i<this._dialogueList.length; i++){
      let item = this._dialogueList[i]
      if(item.id == id){
        if(item.detail && item.detail.order){
          item.detail.order.receipt = true
          this.ctx.$preference.setDialogueList(this._dialogueList, this.ctx.$info.id)
        }
        break;
      }
    }
  },
  getDialogueList() {
    return this._dialogueList;
  },
  hasDialog(id){
    for(let i=0; i<this._dialogueList.length; i++){
      let item = this._dialogueList[i]
      if(item.id == id){
        return true;
      }
    }
    return false;
  },
  
  addSingleChatMsg(item) {
    this.setLastDialogueMsg(item)
    if(this.chatDB.db != null){
      this.addSqlData(this.chatDB.db, SingleChat, [item])
    }
  },
  
  //获取单聊消息
  getSingleChat(key, onGet){
    let db = this.chatDB.db;
    if(db != null){
      let transaction = db.transaction(SingleChat);
      let store = transaction.objectStore(SingleChat);
      let index = store.index("ownerIndex");
      let request = index.getAll(key)
      request.onsuccess = function (e) {
        if(onGet){
          onGet(e.target.result)
        }
      }
    }
  },
  //删除单聊消息
  deleteSingleChat(key){
    let db = this.chatDB.db;
    let self = this
    if(db != null){
      let transaction = db.transaction(SingleChat);
      let store = transaction.objectStore(SingleChat);
      let index = store.index("ownerIndex");
      let request = index.getAll(key)
      request.onsuccess = function (e) {
        for(const item of e.target.result){
          self.deleteDataByKey(db, SingleChat, item.msgno)
        }
      }
    }
  },
  
  //添加群聊消息
  addGroupChatMsg(item) {
    this.setLastDialogueMsg(item)
    if(this.chatDB.db != null){
      this.addSqlData(this.chatDB.db, GroupChat, [item])
    }
  },
  //获取群聊消息
  getGroupChat(key, onGet){
    let db = this.chatDB.db;
    if(db != null){
      let transaction = db.transaction(GroupChat);
      let store = transaction.objectStore(GroupChat);
      let index = store.index("ownerIndex");
      let request = index.getAll(key)
      request.onsuccess = function (e) {
        if(onGet){
          onGet(e.target.result)
        }
      }
    }
  },
  
  //删除群聊消息
  deleteGroupChat(key){
    let db = this.chatDB.db;
    let self = this
    if(db != null){
      let transaction = db.transaction(GroupChat);
      let store = transaction.objectStore(GroupChat);
      let index = store.index("ownerIndex");
      let request = index.getAll(key)
      request.onsuccess = function (e) {
        for(const item of e.target.result){
          self.deleteDataByKey(db, GroupChat, item.msgno)
        }
      }
    }
  },
  
  chatDB: {name: 'chat', version: 2, db: null},
  openDB(name, version) {
    let self = this;
    version = version || 1;
    let request = window.indexedDB.open(name, version);
    request.onerror = function (e) {
      self.ctx.$logger.log('web sql error', e);
    };
    request.onsuccess = function (e) {
      self.chatDB.db = e.target.result;
    };
    request.onupgradeneeded = function (e) {
      let db = e.target.result;
      if (!db.objectStoreNames.contains(SingleChat)) {
        let store = db.createObjectStore(SingleChat, {keyPath: 'msgno'});
        // store.createIndex('noIndex', 'msgno', {unique: true});
        store.createIndex('ownerIndex', 'owner', {unique: false});
      }
  
      if (!db.objectStoreNames.contains(GroupChat)) {
        let store = db.createObjectStore(GroupChat, {keyPath: 'msgno'});
        store.createIndex('ownerIndex', 'owner', {unique: false});
      }
    }
  },
  
  closeDB(db) {
    db.close();
  },
  
  deleteDB(name) {
    window.indexedDB.deleteDatabase(name);
  },
  
  addSqlData(db, storeName, items) {
    let transaction = db.transaction(storeName, 'readwrite');
    let store = transaction.objectStore(storeName);
    
    for (let i = 0; i < items.length; i++) {
      store.add(items[i]);
    }
  },
  
  getDataByKey(db, storeName, value) {
    var transaction = db.transaction(storeName, 'readwrite');
    var store = transaction.objectStore(storeName);
    var request = store.get(value);
    request.onsuccess = function (e) {
      var student = e.target.result;
      console.log(student.name);
    };
  },
  
  updateDataByKey(db, storeName, value) {
    var transaction = db.transaction(storeName, 'readwrite');
    var store = transaction.objectStore(storeName);
    var request = store.get(value);
    request.onsuccess = function (e) {
      var student = e.target.result;
      student.age = 35;
      store.put(student);
    };
  },
  
  deleteDataByKey(db, storeName, value) {
    var transaction = db.transaction(storeName, 'readwrite');
    var store = transaction.objectStore(storeName);
    store.delete(value);
  },
  
  clearObjectStore(db, storeName) {
    var transaction = db.transaction(storeName, 'readwrite');
    var store = transaction.objectStore(storeName);
    store.clear();
  },
  
  deleteObjectStore(db, storeName) {
    var transaction = db.transaction(storeName, 'versionchange');
    db.deleteObjectStore(storeName);
  },
  
  fetchStoreByCursor(db, storeName) {
    var transaction = db.transaction(storeName);
    var store = transaction.objectStore(storeName);
    var request = store.openCursor();
    request.onsuccess = function (e) {
      var cursor = e.target.result;
      if (cursor) {
        console.log(cursor.key);
        var currentStudent = cursor.value;
        console.log(currentStudent.name);
        cursor.continue();
      }
    };
  },
  
  getDataByIndex(db, storeName) {
    var transaction = db.transaction(storeName);
    var store = transaction.objectStore(storeName);
    var index = store.index("ageIndex");
    index.get(26).onsuccess = function (e) {
      var student = e.target.result;
      console.log(student.id);
    }
  },
  
  getMultipleData(db, storeName) {
    var transaction = db.transaction(storeName);
    var store = transaction.objectStore(storeName);
    var index = store.index("nameIndex");
    var request = index.openCursor(null, IDBCursor.prev);
    request.onsuccess = function (e) {
      var cursor = e.target.result;
      if (cursor) {
        var student = cursor.value;
        console.log(student.name);
        cursor.continue();
      }
    }
  },
}

WebSql.install = function (Vue, options) {
  Vue.prototype.$websql = WebSql
}

export default WebSql;



// WEBPACK FOOTER //
// ./src/plugins/websql.js